import { render, staticRenderFns } from "./endpoints-survey.vue?vue&type=template&id=43e4072a&scoped=true&"
import script from "./endpoints-survey.vue?vue&type=script&lang=ts&"
export * from "./endpoints-survey.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e4072a",
  null
  
)

export default component.exports